import React, { useEffect, useLayoutEffect, useState, useMemo } from 'react';
import LoyaltyFlow from './loyaltyFlow';
import ProcessAuthFlow from './processAuthFlow';
import ProcessSaleFlow from './processSaleFlowNewUI';
import ProcessSaleFlowLandscape from './processSaleFlowNewUILandscape';
import { getObjectValue } from '@utility/utills';
import { setInActivityStatus, setScreenSaverStatus } from '@reducers/oauth';
import { connect } from 'react-redux';
import EventEmitter from '@utility/eventSubscribers';
import { flowType } from '@utility/userInfo';
import { bindActionCreators } from 'redux';
import { APP_CONFIG } from '@constants';
import { setPaymentCheck, setSeat } from '@reducers/orders';
import { setOfferAvailable } from '@reducers/payment';
import { setConfirmStageSplit } from '@reducers/stage';
import { urlSearchParams } from '../../utility/utills';
import { deleteLoyaltyAccount } from '@reducers/loyalty';
import { setErrorPopUp, setNotification } from '@reducers/notification';
import cn from 'classnames';

const Payment = props => {
  const [paymentFlowType, setPaymentFlowType] = useState(2);
  const {paymentLandscapeOrientation} = props;

  const isLoyaltyEnabled = getObjectValue(
    () => props.auth.loyaltyInfo?.supportsLoyalty,
    false
  );
  const isDefaultMode = useMemo(
    () =>
      getObjectValue(
        () =>
          !props.deviceInfo.deviceGroup ||
          [0].includes(props.deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );
  const isServer = flowType() === 'serverApp';
  const isTableTop = flowType() === 'tableTop';
  const ShowLandscapeMode =
    isServer &&
    props.deviceInfo?.deviceGroup?.startMode === 0 &&
    paymentLandscapeOrientation;
  const isCounter = useMemo(
    () =>
      getObjectValue(
        () => isServer && [1].includes(props.deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );

  const isDriveThru = useMemo(
    () =>
      getObjectValue(
        () => isServer && [3].includes(props.deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );
  const isCallCenter = useMemo(
    () =>
      getObjectValue(
        () => isServer && [2].includes(props?.deviceInfo?.deviceGroup?.startMode),
        false
      ),
    []
  );
  const screenType = useMemo(() => urlSearchParams('screenType'), []);
  const [isCreditCardPayment, setIsCreditCardPayment] = useState(false);
  const [checkAndSeats, setCheckAndSeats] = useState(null);
  const [loyaltyType, setLoyaltyType] = useState(1);


  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
      if (((isServer && screenType !== '1') || isTableTop) && (!isCounter || !isDriveThru || !isCallCenter)) {
        if (
          !paymentLandscapeOrientation
        ) {
          EventEmitter.changeOrientation({
            orientation: 'portrait',
          });
        }
      }
      if (isServer && screenType === '1') {
        EventEmitter.changeOrientation({
          orientation: 'landscape',
        });
      }
    }
    props.setScreenSaverStatus(false);
    if (
      (isLoyaltyEnabled || props.auth.loyaltyInfo.supportsCoupon) &&
      isDefaultMode
    ) {
      if (urlSearchParams('preAuth')) {
        setPaymentFlowType(3);
      } else {
        if (urlSearchParams('type') === 'stage') {
          setPaymentFlowType(2);
        } else {
          setPaymentFlowType(3);
        }
      }
    } else {
      setPaymentFlowType(3);
    }
    return () => {
      if (window.ReactNativeWebView) {
        EventEmitter.removeListeners('printData', () => {});
      }
      props.setScreenSaverStatus(isServer);
      props.setConfirmStageSplit(false);
    };
  }, []);

  const handleSkipLoyalty = isOfferAvailable => {
    let offerScreenRoute = urlSearchParams('offer') == 'yes' ? true : false;
    if (isOfferAvailable) {
      props.setOfferAvailable(true);
      setLoyaltyType(3);
    } else {
      if (offerScreenRoute) {
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${
            props.paymentCheck.id
          }?ticketSplitTypeId=${Number(
            urlSearchParams('ticketSplitTypeId')
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=28&type=${urlSearchParams(
            'type'
          )}&loyalty=no&offer=yes`,
          { replace: true }
        );
      } else {
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${
            props.paymentCheck.id
          }?ticketSplitTypeId=${Number(
            urlSearchParams('ticketSplitTypeId')
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=28&type=${urlSearchParams('type')}&loyalty=no`,
          { replace: true }
        );
      }
      setPaymentFlowType(3);
    }
  };
  useEffect(() => {
    return () => {
      if (window.ReactNativeWebView) {
        if (isServer || isTableTop) {
          if (!window.sessionStorage.getItem('giftCardpayment')) {
            EventEmitter.changeOrientation({
              orientation: 'landscape',
            });
          }
        }
      }
    };
  }, []);

  const redirecToReceipt = () => {
    setPaymentFlowType(3);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=1&splitValue=1&screenType=22&paidBy=loyalty`,
      { replace: true }
    );
  };

  const deleteLoyalty = (type, dataToSendLoyaltyDelet) => {
    const dataToSend = {
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      storeId: props?.deviceInfo?.storeId,
      checkHeaderId: props?.paymentCheck?.id,
      totalAmount: props?.seat?.paymentCheck?.totalAmount,
      unpaidAmount: props?.seat?.paymentCheck?.unpaidAmount,
      paidAmount: props?.seat?.paymentCheck?.paidAmount,
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
      offer: props?.seat?.paymentCheck?.offer || {},
    };
    props
      .deleteLoyaltyAccount(
        dataToSendLoyaltyDelet ? dataToSendLoyaltyDelet : dataToSend
      )
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        });
        props.setPaymentCheck({
          ...res?.paymentCheck,
          loyalty: res?.loyalty,
          paymentCheck: res?.paymentCheck,
        });
        setLoyaltyType(1);
        if (type === 'backNav')
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${
              props.paymentCheck.id
            }?ticketSplitTypeId=${Number(
              urlSearchParams('ticketSplitTypeId')
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=28&type=payType`,
            { replace: true }
          );
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const setPaymentFlowTypeLoyoltyBack = () => {
    const seat = JSON.parse(window.sessionStorage.getItem('seat'));
    if (urlSearchParams('type') === 'stage') {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/stagepayment/${props.paymentCheck.id}`,
        { replace: true }
      );
    } else if (urlSearchParams('source') === 'stageSplit') {
      props.setPaymentCheck(seat);
      props.navigate(`${APP_CONFIG.BASE_URL}/stage/${props.paymentCheck.id}`, {
        replace: true,
      });
    } else {
      props.setPaymentCheck(seat);
      setPaymentFlowType(3);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
        { replace: true }
      );
    }
  };
  useEffect(() => {
    let offerScreenRoute = urlSearchParams('offer') == 'yes' ? true : false;
    if (!offerScreenRoute) {
      setLoyaltyType(1);
    }
  }, [paymentFlowType]);
  const handlePaymentFlowType = () => {
    switch (paymentFlowType) {
      case 2:
        return (
          <LoyaltyFlow
            {...props}
            paymentFlowType={paymentFlowType}
            setPaymentFlowTypeLoyoltyBack={setPaymentFlowTypeLoyoltyBack}
            handleSkipLoyalty={handleSkipLoyalty}
            redirecToReceipt={redirecToReceipt}
            ShowLandscapeMode={ShowLandscapeMode}
            serverAppTheme={props.serverAppTheme}
            setLoyaltyType={setLoyaltyType}
            loyaltyType={loyaltyType}
            deleteLoyalty={deleteLoyalty}
            setCheckAndSeats={setCheckAndSeats}
            checkAndSeats={checkAndSeats}
          />
        );
      case 3:
        const PaymentComponent = paymentLandscapeOrientation ? ProcessSaleFlowLandscape : ProcessSaleFlow;    
        return (
          <PaymentComponent
            {...props}
            paymentFlowType={paymentFlowType}
            setPaymentFlowType={setPaymentFlowType}
            ShowLandscapeMode={ShowLandscapeMode}
            serverAppTheme={props.serverAppTheme}
            handleSkipLoyalty={handleSkipLoyalty}
            isCreditCardPayment={isCreditCardPayment}
            setIsCreditCardPayment={setIsCreditCardPayment}
            setCheckAndSeats={setCheckAndSeats}
            checkAndSeats={checkAndSeats}
            deleteLoyalty={deleteLoyalty}
            loyaltyType={loyaltyType}
            paymentLandscapeOrientation={paymentLandscapeOrientation}
          />
        );
      case 4:
        return <ProcessAuthFlow {...props} paymentFlowType={paymentFlowType} />;
      default:
        return <div />;
    }
  };

  return (
    <div
      className={cn('col-12 h-100 p-12')}
      style={{
        backgroundColor: props.serverAppTheme?.background_color,
        color: props?.serverAppTheme?.primary_text,
      }}
    >
      {' '}
      {handlePaymentFlowType()}
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.oauth.authInfo,
  deviceInfo: state.oauth.deviceInformation,
  paymentCheck: state.orders.paymentCheck,
  serverAppTheme: state.theme.serverAppTheme,
  seat: state.orders.seats,
  userInfo: state.oauth.loggedInUserData,
  paymentLandscapeOrientation: state.payment.paymentLandscapeOrientation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setInActivityStatus,
      setOfferAvailable,
      setConfirmStageSplit,
      setPaymentCheck,
      setScreenSaverStatus,
      deleteLoyaltyAccount,
      setSeat,
      setErrorPopUp,
      setNotification,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
